import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAdminAuthed } from '../utils/adminAuth';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();

  if (!isAdminAuthed()) {
    return <Navigate to="/admin-login" replace state={{ from: location.pathname }} />;
  }

  return children;
};

export default ProtectedRoute;

